import React from 'react';
import format from 'date-fns/format';
import Typography from '@material-ui/core/Typography';

import { CustomCard } from '../Card/Card';
import StatusBar from './StatusBar';
import PlaceholderIcon from '../../assets/placeholder.png';
import { StyledProjectCard } from '../../styles/templates/Projects';
import { ApplicationInterface } from '../../interfaces/application';

type ProjectCardProps = {
  project: ApplicationInterface;
  onClick: () => void;
};

const ProjectCard: React.FC<ProjectCardProps> = ({ project, onClick }) => {
  const formattedDate = format(new Date(project.lastUpdated as string), 'dd MMMM yyyy, HH:mm');
  return (
    <CustomCard thin>
      <StyledProjectCard cursor="pointer" onClick={onClick}>
        <Typography variant="subtitle1">{project.info.name}</Typography>
        <div>
          <Typography variant="body2">App ID: {project.info.applicationId}</Typography>
          <Typography variant="body2">Version: {project.info.version}</Typography>
        </div>

        <img
          src={project.assets?.appLogoUrl?.contentUrl || PlaceholderIcon}
          alt={project.info.name}
        />

        <Typography className="text-ellipsis">{project.info.description}</Typography>

        <StatusBar status={project.setup.status} />

        <Typography variant="body2">{formattedDate}</Typography>
      </StyledProjectCard>
    </CustomCard>
  );
};

export default ProjectCard;
